import store from '@/store/index'
import ApiService from "./api";

const Product = {
    list(postDatas, params) {
        const country = store.state.settings.country;
        let finalParams = params
        if(country && params.country === undefined)
            finalParams = {...params, country: country}
        return ApiService.post('products', postDatas, {params: finalParams});
    },
    show(identifier, params) {
        return ApiService.get('product/'+identifier, {params: params});
    },
};

export default Product;